module.exports = __webpack_public_path__ + "img/project2_medium.1696ce85.jpg";